var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "basemap-panel" }, [
    _c("div", { staticClass: "basemap-label" }, [_vm._v("BASE MAP")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "basemap-row", attrs: { id: "baseMapContainer" } },
      _vm._l(_vm.visibleBaseMaps, function (base, index) {
        return _c(
          "div",
          {
            key: base,
            staticClass: "basemap-card",
            class: {
              "basemap-card--active": base === _vm.currentBaseMap,
              "basemap-card--focused":
                index === _vm.currentIndex && base !== _vm.currentBaseMap,
            },
            attrs: { id: "Map" + index },
            on: {
              click: function ($event) {
                base !== _vm.currentBaseMap && _vm.selectNewBase(base)
              },
            },
          },
          [
            _c("img", {
              staticClass: "basemap-img",
              attrs: { src: _vm.getBaseMapImg(base), alt: base },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "basemap-name" }, [_vm._v(_vm._s(base))]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }